'use client';
import * as styles from './styles.css';
export { styles as focusFlowStyles };
import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState, useRef, useEffect } from 'react';
import { IconButton } from '@paypalcorp/pp-react-icon-button';
import { CloseIcon } from '@paypalcorp/pp-react-icons';
import { uniqueId, cx } from '@paypalcorp/pp-react-utils';

var _excluded = ["action", "children", "className", "closeButtonLabel", "closeButtonProps", "containerClassName", "mainClassName", "contentContainerRef", "headerClassName", "id", "onClose", "showLogo", "title"];
var FocusFlow = function (_ref) {
  var action = _ref.action,
    children = _ref.children,
    className = _ref.className,
    _ref$closeButtonLabel = _ref.closeButtonLabel,
    closeButtonLabel = _ref$closeButtonLabel === void 0 ? 'close' : _ref$closeButtonLabel,
    _ref$closeButtonProps = _ref.closeButtonProps,
    closeButtonProps = _ref$closeButtonProps === void 0 ? {} : _ref$closeButtonProps,
    containerClassName = _ref.containerClassName,
    mainClassName = _ref.mainClassName,
    contentContainerRef = _ref.contentContainerRef,
    headerClassName = _ref.headerClassName,
    id = _ref.id,
    onClose = _ref.onClose,
    showLogo = _ref.showLogo,
    title = _ref.title,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    headerScroll = _useState2[0],
    setHeaderScroll = _useState2[1];
  var closeButtonRef = useRef();
  var refContent = useRef();
  var contentRef = contentContainerRef || refContent;
  var actionZoneRef = useRef();
  var titleId = "header_".concat(id !== null && id !== void 0 ? id : uniqueId());
  var handleClick = function (evt) {
    if (onClose) {
      onClose(evt);
    }
  };

  /* istanbul ignore next */
  var handleScroll = function () {
    if (contentRef && contentRef.current) {
      var contents = contentRef.current;
      var newHeaderScroll = contents.scrollTop !== 0;
      if (newHeaderScroll !== headerScroll) {
        setHeaderScroll(newHeaderScroll);
      }
    }
  };

  // Put focus on fist focusable item
  /* istanbul ignore next */
  var handleFocus = function () {
    var focused = false;
    // For Forms
    if (!focused && contentRef && contentRef.current) {
      //@ts-ignore
      var focusableEls = contentRef.current.querySelectorAll('a, button, textarea, input, select');
      if (focusableEls.length > 0) {
        focusableEls[0].focus();
        focused = true;
      }
    }

    // Otherwise focus on action item or close button
    if (!focused) {
      if (action && actionZoneRef && actionZoneRef.current) {
        // @ts-ignore
        var focusableActionEl = actionZoneRef.current.querySelectorAll('a, button, select');
        if (focusableActionEl.length > 0) {
          focusableActionEl[0].focus();
        }
      } else {
        var closeButton = closeButtonRef.current;
        if (closeButton) {
          // @ts-ignore
          closeButton.focus();
        }
      }
    }
  };

  // check scroll and put focus
  useEffect(function () {
    handleScroll();
    handleFocus();
  }, []);
  var titleContentZone = /*#__PURE__*/React.createElement("div", {
    className: showLogo ? styles.headerLogo : styles.headerTitle,
    id: titleId,
    "data-ppui": "true"
  }, function titleContents() {
    if (showLogo) {
      return /*#__PURE__*/React.createElement("img", {
        src: "https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-mark-color.svg",
        alt: "paypal-logo",
        "data-ppui": "true"
      });
    }
    return title;
  }());
  var closeButtonZone = /*#__PURE__*/React.createElement("div", {
    className: styles.headerClose,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    svgIconComponent: CloseIcon,
    onClick: function onClick(e) {
      return handleClick(e);
    },
    buttonType: "tertiary"
  }, closeButtonProps, {
    ref: closeButtonRef,
    "data-ppui": "true"
  }), closeButtonLabel));
  var actionZone = action ? /*#__PURE__*/React.createElement("div", {
    className: styles.headerAction,
    ref: actionZoneRef,
    "data-ppui": "true"
  }, action) : /*#__PURE__*/React.createElement("div", {
    className: styles.headerAction,
    "data-ppui": "true"
  });
  var header = /*#__PURE__*/React.createElement("header", {
    className: cx(styles.header, headerScroll && styles.headerScrolled, headerClassName),
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.headerContent,
    "data-ppui": "true"
  }, actionZone, titleContentZone, closeButtonZone));
  return /*#__PURE__*/React.createElement("main", {
    className: cx(styles.base, mainClassName),
    id: id,
    "data-testid": "focusflow",
    "data-ppui-info": "focus-flow_3.0.6__8.5.0",
    "aria-live": "polite",
    "aria-label": showLogo ? title : ''
  }, /*#__PURE__*/React.createElement("article", _extends({
    className: cx(styles.container, containerClassName)
  }, rest, {
    "aria-hidden": "false",
    "data-ppui": "true"
  }), header, /*#__PURE__*/React.createElement("section", {
    className: cx(styles.content, className),
    onScroll: handleScroll,
    ref: contentRef,
    "data-ppui": "true"
  }, children)));
};

export { FocusFlow };
